import { Pipe, PipeTransform } from '@angular/core';
import { Shift } from '@wilson/interfaces';

@Pipe({
  name: 'isPartOfProject',
  standalone: true,
})
export class IsPartOfProjectPipe implements PipeTransform {
  transform(object: Pick<Shift, 'projectId'>): boolean {
    return !!object?.projectId;
  }
}
